import React, { Component } from 'react';
import CommunityInbox from './CommunityInbox';

class MainInboxContainerView extends Component {
    render() {
        return (
            <CommunityInbox otherPersonId={parseInt(this.props.routeParams.id, 10)}
                uniqueName={this.props.routeParams.unique_name}/>
        );
    }
}

export default MainInboxContainerView;
